const Formular = ({children}) => {

    return (children)
}

export default Formular

